<template>
    <input
        :id="id || name"
        v-model="mutableValue"
        :type="type"
        :name="name"
        class="form-control"
        :disabled="disabled"
        :class="{
            'form-control-plaintext': plaintext,
        }"
        @input="onInput()"
    />
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
      default: null,
    },
    type: {
      default: "text",
      type: String,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
    plaintext: {
      default: false,
      type: Boolean,
      required: false,
    },
    modelValue: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data() {
    return {
      mutableValue: this.modelValue,
    };
  },

  emits: [
    "update:modelValue",
  ],

  watch: {
    modelValue(newValue) {
      this.mutableValue = newValue;
    },
  },

  methods: {
    onInput() {
      // emit event to update parent data
      this.$emit("update:modelValue", this.mutableValue);
    },
  },
};
</script>
